import React from 'react';
import { Button } from 'reactstrap';

interface ActionButtonProps {
  color: 'success' | 'primary' | 'warning' | 'danger' | 'secondary' | 'info' | 'dark' | 'light';
  onClick?: () => void;
  icon: string;
  label: string;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({ color, onClick, icon, label, disabled = false }) => {
  return (
    <button className={`btn btn-soft-${color} d-inline-flex align-items-center btn-sm`}
      color={color}
      onClick={onClick}
      disabled={disabled}
      style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
    >
      <i className={`${icon} align-middle me-1`}></i> {label}
    </button>
  );
};

export default ActionButton; 